import React, { useEffect, useState } from "react";
import DocumentMeta from "react-document-meta";
import LoginHeader from "../Common/LoginHeader";
import Footer from "../Common/Footer";
import LeftTab from "../Common/LeftTab";
import { toast } from "react-toastify";
import {
  useRefralHistoryQuery,
  useRefralIncomeQuery,
} from "../../redux/profileApi";
import config from "../../utils/config";
const { redirectUrl } = config;

const meta = {
  title: "Refer & Earn | Green Crypto Exchange",
  description:
    "Green Crypto Exchange Live Makes The Buying And Selling Of Crypto Coin Way More Effective And Profitable. We Are A Low Cost Crypto Exchange In India Like Bitcoin And Dogecoin.",
  canonical: "https://Green CryptoExchange.live/buy-sell-crypto-online",
  meta: {
    charset: "utf-8",
    name: {
      keywords:
        "BTC Exchange, Crypto Trading Platform, Best Crypto Converter, Indian Crypto Exchange",
    },
  },
};

const ReferFunction = () => {
  const [isKycPending, setIsKycPending] = useState(false);
  const [activeTab, setActiveTab] = useState("history");

  const [page, setPage] = useState(1);
  const limit = 10;

  const { data: referalHistory, isFetching: isFetchingHistory } =
    useRefralHistoryQuery({ page, limit });

  // Income API
  const { data: referalIncome, isFetching: isFetchingIncome } =
    useRefralIncomeQuery({ page, limit });

  useEffect(() => {
    if (referalHistory) {
      setIsKycPending(referalHistory.kyc_status !== 1);
    }
  }, [referalHistory]);

  const copyToClipboard = async (text) => {
    if (!text) {
      return false;
    }

    try {
      if (window.isSecureContext && navigator?.clipboard?.writeText) {
        await navigator.clipboard.writeText(text);
        return true;
      }
    } catch (error) {
      // Fallback to execCommand below.
    }

    try {
      const textarea = document.createElement("textarea");
      textarea.value = text;
      textarea.setAttribute("readonly", "");
      textarea.style.position = "fixed";
      textarea.style.top = "-1000px";
      textarea.style.left = "-1000px";
      document.body.appendChild(textarea);
      textarea.select();
      const result = document.execCommand("copy");
      document.body.removeChild(textarea);
      return result;
    } catch (error) {
      return false;
    }
  };

  // ✅ Copy function
  const handleCopy = async (text, type) => {
    const didCopy = await copyToClipboard(text);
    toast.dismiss();
    if (!didCopy) {
      toast.error("Unable to copy");
      return;
    }
    toast.success("Copied");
  };

  // ✅ History Rows
  const showReferHistoryRows = () =>
    referalIncome?.data?.length > 0 ? (
      referalIncome.data.map((item, index) => (
        <tr key={item.id}>
          <td>{(page - 1) * limit + index + 1}</td>
          <td>{item?.email ?? "-"}</td>
          <td>{item.phone ?? "-"}</td>
          <td>{item.level ?? "-"}</td>
          <td>{item?.kyc_status == 1 ? "Completed" : "Pending"}</td>
          <td>{item.created_at}</td>
        </tr>
      ))
    ) : (
      <tr>
        <td colSpan="5" className="text-center">
          {isFetchingHistory ? "Loading..." : "No records found"}
        </td>
      </tr>
    );

  // ✅ Income Rows (different columns)
  const showReferIncomeRows = () =>
    referalHistory?.data?.length > 0 ? (
      referalHistory.data.map((item, index) => (
        <tr key={item.id}>
          <td>{(page - 1) * limit + index + 1}</td>
          <td>{item.symbol}</td>
          <td>{item.amount}</td>
          <td>{item.payment_details.level ?? "-"}</td>
          <td>{item.payment_details?.email}</td>
          <td>{item?.created?.replace("T", " ").replace("Z", " ")}</td>
        </tr>
      ))
    ) : (
      <tr>
        <td colSpan="5" className="text-center">
          {isFetchingIncome ? "Loading..." : "No records found"}
        </td>
      </tr>
    );

  // ✅ Pagination controls
  const renderPagination = (totalPages) => (
    <div className="d-flex justify-content-between align-items-center mt-3">
      <button
        className="btn btn-sm btn-outline-primary"
        disabled={page === 1}
        onClick={() => setPage((prev) => Math.max(prev - 1, 1))}
      >
        Previous
      </button>

      <span>
        Page {page} of {totalPages}
      </span>

      <button
        className="btn btn-sm btn-outline-primary"
        disabled={page === totalPages}
        onClick={() => setPage((prev) => Math.min(prev + 1, totalPages))}
      >
        Next
      </button>
    </div>
  );

  const blurrContent = () => (
    <div className="refer-main-outer position-relative">
      <div className="kyc-overlay d-flex justify-content-center align-items-center">
        <h2 className="fw-bold">Please complete your kyc first</h2>
      </div>
      <div className="blurred">{referalContent()}</div>
    </div>
  );

  const referalContent = () => (
    <div className="refer-main-outer">
      <div className="row">
        <div className="col-md-4">
          <h5>Refer & Earn</h5>
          <div className="refer-left-outer white_box_refer">
            <div className="refer-img-outer text-center mb-4">
              <img
                className="img-fluid"
                src="/assets/img/refer.png"
                alt="refer"
              />
            </div>
            <h6>Refer us to your friends or family & get reward.</h6>

            <h6>Referral Code</h6>
            <div className="form-group position-relative mb-2">
              <input
                className="form-control fs12"
                type="text"
                readOnly
                value={referalHistory?.referal_code || ""}
              />
              <button
                type="button"
                className="btn btn_man position-absolute copy_button"
                onClick={() =>
                  handleCopy(referalHistory?.referal_code || "", "code")
                }
              >
                <i className="fa fa-clone" aria-hidden="true"></i>
              </button>
            </div>
            <h6>Referral URL</h6>
            <div className="form-group position-relative mb-2">
              <input
                className="form-control fs12"
                type="text"
                readOnly
                value={
                  redirectUrl + "?ref=" + (referalHistory?.referal_code || "")
                }
              />
              <button
                type="button"
                className="btn btn_man position-absolute copy_button"
                onClick={() =>
                  handleCopy(
                    redirectUrl +
                      "?ref=" +
                      (referalHistory?.referal_code || ""),
                    "url"
                  )
                }
              >
                <i className="fa fa-clone" aria-hidden="true"></i>
              </button>
            </div>
          </div>
        </div>

        <div className="col-md-8 mt-4">
          <div className="refer-history-outer white_box_refer">
            {/* 🔹 Tabs */}
            <div className="d-flex mb-3">
              <button
                className={`tab-btn me-2 ${
                  activeTab === "history" ? "active" : ""
                }`}
                onClick={() => setActiveTab("history")}
              >
                Referral History
              </button>
              <button
                className={`tab-btn ${activeTab === "income" ? "active" : ""}`}
                onClick={() => setActiveTab("income")}
              >
                Referral Income
              </button>
            </div>

            {/* 🔹 Tab Content */}
            {activeTab === "history" && (
              <>
                <h5>Referral History</h5>
                <div className="refer-right-outer">
                  <table className="table table-striped w-100 text-left refer-history">
                    <thead>
                      <tr>
                        <th>Sr No.</th>
                        <th>Email</th>
                        <th>Mobile</th>
                        <th>Level</th>
                        <th>KYC Status</th>
                        <th>Created At</th>
                      </tr>
                    </thead>
                    <tbody>{showReferHistoryRows()}</tbody>
                  </table>
                  {renderPagination(
                    referalHistory?.pagination?.total_pages || 1
                  )}
                </div>
              </>
            )}

            {activeTab === "income" && (
              <>
                <h5>Referral Income</h5>
                <div className="refer-right-outer">
                  <table className="w-100 text-left refer-history">
                    <thead>
                      <tr>
                        <th>Sr No.</th>
                        <th>Currency</th>
                        <th>Amount</th>
                        <th>Level</th>
                        <th>Referred To</th>
                        <th>Date & Time</th>
                      </tr>
                    </thead>
                    <tbody>{showReferIncomeRows()}</tbody>
                  </table>
                  {renderPagination(
                    referalIncome?.pagination?.total_pages || 1
                  )}
                </div>
              </>
            )}
          </div>
        </div>
      </div>
    </div>
  );

  return (
    <div className="">
      <DocumentMeta {...meta}>
        <LoginHeader />
        <div className="new_inpage">
          <div className="container">
            <LeftTab />
            {isKycPending ? blurrContent() : referalContent()}
          </div>
        </div>
        <Footer />
      </DocumentMeta>
    </div>
  );
};

export default ReferFunction;
